var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"form-group col-md-12\" style=\"padding-right: 0\"> <h5>{{ 'time_slots.amount' | i18next }}</h5> <div class=\"select-fa-arrow default\"> <select class=\"select-wrapper\" ng-options=\"amount as $ctrl.getProductAmountText(amount) for amount in $ctrl.productAmounts\" ng-model=\"$ctrl.selectedAmount\" ng-change=\"$ctrl.selectAmount()\"> </select> </div> </div>";
var id1="winresReservationTimeAmountSelect.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationTimeAmountSelect/winresReservationTimeAmountSelect.html
// module id = 474
// module chunks = 2